export class DistributorInfo {
    name: string;
    contactNumber: string;
    email: string;
    distributorId: string;
    level: string;
    memberType: string;
    memberId: number;
    memberTypeId: number;
    firstName?: string;
    lastName?: string;
    middleName?: string;
    homeCountryCode?: string;
    displayName?: string;
    privacyRequested?: string;
    displayMiddleName?: boolean;
}


// WEBPACK FOOTER //
// ./src/app/customerservice/interface/ticketingsystem/distributor-info.ts